import { useEffect, useState } from "react";
import $ from "jquery";
import "summernote/dist/summernote-lite.css";
import "summernote/dist/summernote-lite.js";
import { Link, useNavigate, useParams } from "react-router-dom";
import api from "../../../../services/api";
import VariantButton from "../../../../components/variant-button/variant-button";
import ImageUpload from "../../../../components/image-upload/image-upload";

export default function EditBlog() {
  const [permissions, setPermissions] = useState(undefined);
  useEffect(() => {
    fetchPermissions();
  }, []);

  const fetchPermissions = async () => {
    try {
      const res = await api.get("/users/permissions");
      setPermissions(res.data.data);
    } catch (error) {}
  };

  const [form, setForm] = useState({
    id: "",
    title: "",
    slug: "",
    image_url: "",
    author: "",
    blog_type_id: "",
  });
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();
  const [previewContent, setPreviewContent] = useState("");
  const [blogTypes, setBlogTypes] = useState([]);
  useEffect(() => {
    $("#content").summernote({
      height: 200,
      placeholder: "Nội dung",
      toolbar: [
        ["style", ["style"]],
        ["font", ["bold", "italic", "underline", "clear"]],
        ["color", ["color"]],
        ["para", ["ul", "ol", "paragraph"]],
        ["table", ["table"]],
        ["insert", ["link", "picture"]],
        ["view", ["fullscreen", "codeview", "help"]],
      ],
      callbacks: {
        onChange: (contents) => {
          setPreviewContent(contents);
        },
      },
    });

    const fetchData = async () => {
      try {
        const typesResponse = await api.get("/blogTypes");
        setBlogTypes(
          typesResponse.data.data.map((item) => {
            return { label: item.name, value: item.id };
          }),
        );

        const blogResponse = await api.get(`/blogs/${id}`);
        if (blogResponse.data.data) {
          setForm({
            id: blogResponse.data.data.id,
            title: blogResponse.data.data.title,
            slug: blogResponse.data.data.slug || "",
            image_url: blogResponse.data.data.image_url || "",
            author: blogResponse.data.data.author,
            blog_type_id: blogResponse.data.data.blog_type_id || "",
          });
          $("#content").summernote("code", blogResponse.data.data.content);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Không thể tải dữ liệu blog hoặc danh sách loại.");
      }
    };

    permissions && permissions.includes("blogs.update") && fetchData();

    return () => {
      $("#content").summernote("destroy");
    };
  }, [id, permissions]);

  const handleSubmit = async () => {
    try {
      const content = $("#content").summernote("code");
      if (
        !form.title ||
        !form.slug ||
        !form.author ||
        !form.image_url ||
        !form.blog_type_id ||
        !content.trim()
      ) {
        setError(
          "Tiêu đề, slug, hình ảnh, nội dung, loại và tác giả là bắt buộc.",
        );
        return;
      }

      await api.put(`/blogs/${form.id}`, {
        title: form.title,
        slug: form.slug,
        image_url: form.image_url,
        content,
        author: form.author,
        blog_type_id: form.blog_type_id,
      });
      navigate("/blogs");
    } catch (error) {
      console.error("Error updating blog:", error);
      setError("Không thể cập nhật blog. Vui lòng thử lại.");
    }
  };

  return (
    permissions &&
    permissions.includes("blogs.update") && (
      <div className="flex-1 overflow-y-auto p-6 bg-gray-100 min-h-screen">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">Quản lý Blog</h1>
        <div className="mb-8 p-6 bg-white shadow-xl rounded-lg">
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">
            Sửa Blog
          </h2>
          {error && (
            <div className="relative">
              <p className="bg-red-500 text-white p-2 mb-4 rounded-md shadow">
                {error}
              </p>
              <button
                onClick={() => setError("")}
                className="absolute right-3 top-1 text-white text-xl hover:text-gray-200 active:translate-y-1"
              >
                &times;
              </button>
            </div>
          )}
          <ImageUpload />
          <div className="space-y-4">
            <input
              type="text"
              placeholder="Tiêu đề"
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
              className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <input
              type="text"
              placeholder="Slug (ví dụ: bai-viet-1)"
              value={form.slug}
              onChange={(e) => setForm({ ...form, slug: e.target.value })}
              className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <input
              type="text"
              placeholder="URL hình ảnh"
              value={form.image_url}
              onChange={(e) => setForm({ ...form, image_url: e.target.value })}
              className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <select
              value={form.blog_type_id}
              onChange={(e) =>
                setForm({ ...form, blog_type_id: e.target.value })
              }
              className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Chọn loại blog</option>
              {blogTypes.map((type, key) => (
                <option key={key} value={type.value} selected>
                  {type.label}
                </option>
              ))}
            </select>
            <textarea
              id="content"
              className="w-full p-2 border border-gray-300 rounded-lg"
            />
            <input
              type="text"
              placeholder="Người viết bài"
              value={form.author}
              onChange={(e) => setForm({ ...form, author: e.target.value })}
              className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <div className="flex space-x-3 justify-end">
              <div className="w-[120px]">
                <VariantButton
                  props={{
                    onClick: handleSubmit,
                    title: "Cập nhật",
                  }}
                />
              </div>
              <div className="w-[120px]">
                <Link to={"/blogs"}>
                  <VariantButton
                    props={{
                      onClick: null,
                      title: "Trở lại",
                    }}
                  />
                </Link>
              </div>
            </div>
          </div>
          {previewContent && (
            <div className="mt-6">
              <h3 className="text-xl font-semibold text-gray-700 mb-2">
                Xem trước
              </h3>
              <div
                className="note-editable p-4 border border-gray-300 rounded-lg bg-gray-50 prose max-w-none"
                dangerouslySetInnerHTML={{ __html: previewContent }}
              />
            </div>
          )}
        </div>
      </div>
    )
  );
}
